import { AnyAction } from "redux";
import { call, SagaGenerator, takeEvery } from "typed-redux-saga";
import { Action } from "typescript-fsa";

import { Events } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/core/store";
import { TreeEngineActions } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/client";

import { fetchSagaFactory } from "../../../app/sagas/fetchSagaFactory";
import { RESOURCE_KEYS } from "../../../localization";
import { executeBusy } from "../../../utilities/workflowUtils";

import { getFvKeyFromTextbausteinVerfahrenNode, handleTextbausteinTransferError } from "../textbausteinSagaUtils";

export function* exportTextbausteineSaga(): SagaGenerator<void> {
	yield* takeEvery(
		(action: AnyAction) => {
			return (
				TreeEngineActions.event.match(action) &&
				Events.onNodeEventButtonClicked.match(action.payload.engineAction) &&
				["export_textbausteine"].includes(action.payload.engineAction.payload.button.event)
			);
		},
		function* (action: Action<TreeEngineActions.EventPayload<Action<Events.NodeEventButtonClickedPayload>>>) {
			yield* call(executeBusy, function* () {
				yield* call(handle, action);
			});
		}
	);
}

function* handle(
	action: Action<TreeEngineActions.EventPayload<Action<Events.NodeEventButtonClickedPayload>>>
): SagaGenerator<void> {
	const fachverfahrenKey = yield* call(
		getFvKeyFromTextbausteinVerfahrenNode,
		action.payload.engineAction.payload.nodeIdentifier,
		action.payload.activityId
	);
	if (!fachverfahrenKey) {
		return;
	}

	yield* call(
		fetchSagaFactory(
			{
				relativeUrl: `/textbausteine/export?fachverfahrenKey=${fachverfahrenKey}`,
				method: "POST"
			},
			function* handleResponse(response) {
				const blob = yield* call(response.blob.bind(response));
				const downloadUrl = URL.createObjectURL(blob);
				const link = document.createElement("a");
				link.href = downloadUrl;
				link.download = `textbausteine_${fachverfahrenKey}_export.json`;
				link.click();
				URL.revokeObjectURL(downloadUrl);
			},
			function* handleError(error) {
				yield* call(
					handleTextbausteinTransferError,
					fachverfahrenKey,
					RESOURCE_KEYS.features.notification.error.textbausteine.export,
					error
				);
			}
		)
	);
}
